module.exports = __webpack_public_path__ + "media/images/social-share-button/reddit-c8eddc7a28ab7decf7364517657ac237.svg";